import { Grid } from '@interstate/components/Grid';
import type { ComponentProps, ReactNode } from 'react';

type LineItemRowProps = {
    styles?: ComponentProps<typeof Grid>['sx'];
    children: ReactNode;
};

const LineItemRow = ({ children, styles }: LineItemRowProps) => (
    <Grid
        container
        sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingY: '0.857rem',
            pr: 1,
            ...styles
        }}
    >
        {children}
    </Grid>
);

export default LineItemRow;
